import { useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { signOut } from 'actions/auth'
import { signOutSelector } from 'selectors'

const SignOut = () => {
  const dispatch = useDispatch()
  const { profile, appRootPath } = useSelector(signOutSelector)

  useEffect(() => {
    dispatch(signOut())
  }, [dispatch])

  if (!profile) {
    return <Redirect to={appRootPath} />
  }
  return null
}

export default SignOut
